export default "__VITE_ASSET__CLcQW7FP__"